import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M21.5 4.5v15M4.5 2.5h15M2.5 19.5v-15M19.5 21.5h-15\"></path><rect width=\"4\" height=\"4\" x=\".5\" y=\".5\" rx=\"1\" ry=\"1\"></rect><rect width=\"4\" height=\"4\" x=\"19.5\" y=\".5\" rx=\"1\" ry=\"1\"></rect><rect width=\"4\" height=\"4\" x=\".5\" y=\"19.5\" rx=\"1\" ry=\"1\"></rect><rect width=\"4\" height=\"4\" x=\"19.5\" y=\"19.5\" rx=\"1\" ry=\"1\"></rect>", 5)
const _hoisted_7 = [
  _hoisted_2
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_7, 8, _hoisted_1))
}
}

})